export default {
  BALL_SPEED: 3.55,
  BLOCK_WIDTH: 66,
  BLOCK_HEIGHT: 40,
  BALL_DIAMETER: 20,
  BALL_RADIUS: 10,
  BOUNCE_AMOUNT: 15,
  DIAMOND_SCORE: 100,
  BLOCK_SCORE: 3,
  KEY_SCORE: 25,
  LOCK_SCORE: 50,
  BONUS_INCREMENTS: 46,
  BONUS_TIME_MS: 1250,
  BONUS_VALUE_POINTS: 25,
  ADDITIONAL_BALL_SCORE: 5000,
}
